import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h-full bg-white shadow-modal w-full rounded-xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex flex-col justify-start items-start p-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "t-22m text-wrh-blue-dark" }, /*#__PURE__*/_toDisplayString('Conversations'))
], -1)
const _hoisted_3 = { class: "pt-2 flex-grow overflow-y-auto flex flex-col justify-start space-y-4 scrollbar-thin scrollbar-thumb-wrh-gray-dark scrollbar-track-wrh-gray-extralight px-6 pb-12" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex flex-col items-start -space-y-2 overflow-hidden w-8 flex-shrink-0" }
const _hoisted_6 = { class: "flex flex-col items-start flex-grow ml-3" }
const _hoisted_7 = { class: "t-14m text-black line-clamp-1 text-left" }
const _hoisted_8 = {
  key: 0,
  class: "t-11r text-wrh-blue-light line-clamp-1 text-left"
}
const _hoisted_9 = {
  key: 1,
  class: "t-12r text-wrh-gray-dark line-clamp-1 mt-1 text-left"
}
const _hoisted_10 = {
  key: 2,
  class: "t-10r text-wrh-gray-medium line-clamp-1 mt-1 text-left"
}

import type { PropType } from 'vue';
import { computed } from 'vue';
import { formatDistance } from 'date-fns';
import { Conversation } from '../../../models/conversation';
import UserAvatar from '../../../components/UserAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  activeConversationId: {
    type: String,
    required: false,
    default: '532784jdv',
  },
  currentUserId: {
    type: String,
    required: false,
    default: '576382940jd',
  },
},
  emits: ['toggleConversation'],
  setup(__props, { emit }) {

const props = __props


const conversations = [
  {
    uid: '532784jdv',
    adminsData: [{
      displayName: 'Leonard cooper',
    },
    {
      displayName: 'Leonard cooper',
    },
    {
      displayName: 'Leonard cooper',
    },
    ],
    homebuyersData: {},
  },
];



const others = computed(() => {
  const uid = props.currentUserId || '';
  const convos = {} as {[uid: string]: {
    uid: string
    displayName?: string
    photoURL?: string
    roles?: string[]
  }[]};

  conversations.forEach((c) => {
    const admins = Object.values(c.adminsData || {});
    const homebuyers = Object.values(c.homebuyersData || {}).filter((h) => h.uid !== uid);
    convos[c.uid] = [...admins, ...homebuyers];
  });
  return convos;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(conversations, (conversation) => {
        return _createElementVNode("button", {
          key: conversation.uid,
          class: _normalizeClass(["w-full shadow-modal flex items-start justify-start p-3.5 rounded-xl focus:outline-none focus:ring-1 focus:ring-wrh-blue-light", [
          props.activeConversationId !== conversation.uid && 'bg-white',
          props.activeConversationId === conversation.uid && 'ring-1 ring-wrh-blue-light bg-wrh-blue-background',
        ]]),
          onClick: ($event: any) => (emit('toggleConversation', conversation.uid))
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(others)[conversation.uid], (other) => {
              return (_openBlock(), _createElementBlock("div", {
                key: other.uid,
                class: "h-8 w-8"
              }, [
                (conversation.adminsData)
                  ? (_openBlock(), _createBlock(UserAvatar, {
                      key: 0,
                      user: other,
                      class: "h-8 w-8"
                    }, null, 8, ["user"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(others)[conversation.uid].map(o => o.displayName).filter(Boolean).join(", ")), 1),
            (_unref(others)[conversation.uid].length === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString('sales')))
              : _createCommentVNode("", true),
            (conversation.lastMessageData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(conversation.lastMessageData.body), 1))
              : _createCommentVNode("", true),
            (conversation.lastMessageData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(formatDistance)(conversation.lastMessageData.sentAt.toDate(), Date.now(), { addSuffix: true })), 1))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_4)
      }), 64))
    ])
  ]))
}
}

})